// extracted by mini-css-extract-plugin
export default {"content":"Layout_content__sooUm","backgroundColor":"Layout_backgroundColor__a3-iE"};